import React from "react";
import { Card, Badge, Button } from "react-bootstrap";
import { FaMapMarkerAlt, FaEnvelope, FaChevronRight, FaPen } from "react-icons/fa";
import { KPI, getDashboardCardSurface } from "constants/dashboardColors";

const AssistenciaCard = ({ assistencia, onClick, onEdit, showEdit = false }) => {
  const isAtivo = assistencia.status === "ativo";

  return (
    <Card
      className="border-0 h-100"
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "transform 0.15s, box-shadow 0.15s",
        borderRadius: '18px',
        borderTop: `4px solid ${isAtivo ? KPI.secondary : '#6c757d'}`,
        ...getDashboardCardSurface(),
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "";
      }}
    >
      <Card.Body className="p-3">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <h6 className="fw-bold mb-0" style={{ fontSize: "1rem", color: "var(--text-color)" }}>{assistencia.nome}</h6>
          <Badge bg={isAtivo ? "success" : "secondary"} pill className="ms-2 flex-shrink-0">
            {isAtivo ? "Ativo" : "Inativo"}
          </Badge>
        </div>

        <div className="d-flex align-items-center gap-2 mb-1" style={{ fontSize: "0.82rem", color: "var(--text-muted)" }}>
          <FaMapMarkerAlt size={12} />
          <span>{assistencia.cidade}/{assistencia.estado}</span>
        </div>

        <div className="d-flex align-items-center gap-2 mb-3" style={{ fontSize: "0.82rem", color: "var(--text-muted)" }}>
          <FaEnvelope size={12} />
          <span>{assistencia.email}</span>
        </div>

        <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderTop: "1px solid var(--card-border)" }}>
          <div className="d-flex gap-3">
            <div>
              <div style={{ fontSize: "0.7rem", color: "var(--text-muted)" }}>Chave Assist.</div>
              <div className="fw-bold" style={{ fontSize: "0.85rem", color: "var(--text-color)" }}>R$ {assistencia.valor}</div>
            </div>
            <div>
              <div style={{ fontSize: "0.7rem", color: "var(--text-muted)" }}>Help Desk</div>
              <div className="fw-bold" style={{ fontSize: "0.85rem", color: "var(--text-color)" }}>R$ {assistencia.valorhp}</div>
            </div>
            <div>
              <div style={{ fontSize: "0.7rem", color: "var(--text-muted)" }}>Loc Solution</div>
              <div className="fw-bold" style={{ fontSize: "0.85rem", color: "var(--text-color)" }}>R$ {assistencia.valorloc}</div>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            {showEdit && onEdit && (
              <Button
                variant="outline-success"
                size="sm"
                className="btn-theme-outline py-0 px-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit();
                }}
                title="Editar assistência"
              >
                <FaPen size={12} />
              </Button>
            )}
            <FaChevronRight size={14} style={{ color: "var(--text-muted)" }} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AssistenciaCard;
